import { useEffect, useState } from "react";
import { Stack, TextField, Button, Typography, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useSnackbar } from "notistack";
import PinCodeInput from "./PinCodeInput";
import { resendTwoFactorVerification } from "src/DAL/Login/Login";

// ----------------------------------------------------------------------

const RESEND_TIME = 60; // 1 minute

export default function TwoFactorVerificationFormLogin({
    onhandleVerify,
    isLoading,
    accessToken,
    setStep,
}) {
    const [code, setCode] = useState("");
    const { enqueueSnackbar } = useSnackbar();

    const [resending, setResending] = useState(false);
    const [timer, setTimer] = useState(0);

    // Countdown effect
    useEffect(() => {
        if (timer <= 0) return;

        const interval = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timer]);


    const handleSubmit = (e) => {
        e.preventDefault();
        if (code.length !== 6) return;
        const formData = new FormData();
        formData.append("verification_code", code);
        formData.append("detail_access_token", accessToken);
        onhandleVerify(formData);
    };

    const handleResendCode = async () => {
        if (timer > 0 || resending) return;

        setResending(true);
        const formData = new FormData();
        formData.append("detail_access_token", accessToken);

        const result = await resendTwoFactorVerification(formData);

        if (result.code === 200) {
            enqueueSnackbar(result.message, { variant: "success" });
            setTimer(RESEND_TIME);
            setCode("");
        } else {
            enqueueSnackbar(result.message, { variant: "error" });
        }

        setResending(false);
    };

    return (
        <form onSubmit={handleSubmit}>
            <Stack spacing={3} sx={{ mt: 3 }}>
                <PinCodeInput value={code} onChange={setCode} />
            </Stack>

            {/* Resend Section */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                sx={{ my: 2 }}
            >
                <Typography variant="body2" color={"text.secondary"} sx={{ display: "flex", gap: 0.5 }}>
                    Didn’t receive the code?
                    <span
                        style={{
                            color: "#EC8945",
                            cursor: timer > 0 || resending ? "not-allowed" : "pointer",
                            opacity: timer > 0 || resending ? 0.6 : 1,
                            fontWeight: 500,
                        }}
                        onClick={timer > 0 || resending ? undefined : handleResendCode}
                    >
                        {resending
                            ? "Resending..."
                            : timer > 0
                                ? `Resend it (${timer}s)`
                                : "Resend it"}
                    </span>
                </Typography>

            </Stack>

            <LoadingButton
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                loading={isLoading}
                disabled={code.length !== 6}
            >
                Verify
            </LoadingButton>
            <Box sx={{ mt: 3, textAlign: "center" }}>
                <Typography
                    sx={{ cursor: "pointer", fontWeight: 500 }}
                    fullWidth
                    variant="body2"
                    color="primary"
                    onClick={() => setStep("login")}
                >
                    BACK TO LOGIN
                </Typography>
            </Box>
        </form>
    );
}

